import { EntryComponentProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/Entry/Entry'
import { FC } from 'react'
import Preloader from '../../../../Preloader'
import LoadableImage from '../../../../UI/LoadableImage'
import { MOKUP_MENTION_NAME, TTransformedMention } from '../MessageField'

import './MentionItem.scss'

type TMentionItemProps = React.PropsWithChildren<EntryComponentProps>

const MentionItem: FC<TMentionItemProps> = ({
  isFocused,
  onMouseDown,
  onMouseEnter,
  onMouseUp,
  mention: mentionData,
  ...rest
}) => {
  const { avatar, id, mention, name, errorMessage } = mentionData as TTransformedMention

  const renderMentionStatus = (status: MOKUP_MENTION_NAME) => {
    switch (status) {
      case MOKUP_MENTION_NAME.LOADING: {
        return <Preloader />
      }
      case MOKUP_MENTION_NAME.EMPTY: {
        return 'Empty list'
      }
      case MOKUP_MENTION_NAME.ERROR: {
        return errorMessage ? errorMessage : (
          <>
            <div>Error getting mentions.</div>
            <div>Please try again.</div>
          </>
        )
      }
      default:
        return null
    }
  }

  return id ? (
    <div
      className={`mention-list-item ${isFocused && 'active'}`}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseUp={onMouseUp}
    >
      {avatar && (
        <div className='mention-list-item__avatar'>
          <LoadableImage media={avatar} />
        </div>
      )}
      <div className='mention-list-item__user-data'>
        <div className='mention-list-item__user-data__name'>{name}</div>
        <div className='mention-list-item__user-data__mention'>{mention}</div>
      </div>
    </div>
  ) : (
    <div className={`mention-list-info`}>{renderMentionStatus(name as MOKUP_MENTION_NAME)}</div>
  )
}

export default MentionItem
